export default "__VITE_ASSET__2156030c__"